export enum AppBundle {
  Journeys = 'journeys',
  Pipelines = 'pipelines',
  DesignStudio = 'design-studio',
}

export function isAppBundle(app: string) {
  return (Object.values(AppBundle) as string[]).includes(app);
}

export const AppBundleRoutes = {
  [AppBundle.Journeys]: '/journeys',
  [AppBundle.Pipelines]: '/pipelines',
  [AppBundle.DesignStudio]: '/design-studio',
};

export const AppBundleNames = {
  [AppBundle.Journeys]: 'Journeys',
  [AppBundle.Pipelines]: 'Data Pipelines',
  [AppBundle.DesignStudio]: 'Design Studio',
};
